export function checkMandatoryDocuments(opportunityId, callbackSuccess, callbackError) {
  return {
    type: "CHECK_MANDATORY_DOCUMENTS",
    payload: {
      opportunityId,
      callbackSuccess,
      callbackError,
    },
  };
}

export function fetchDocumentsList(opportunityId, callbackSuccess, callbackError) {
  return {
    type: "FETCH_DOCUMENTS_LIST",
    payload: {
      opportunityId,
      callbackSuccess,
      callbackError,
    },
  };
}

export function setDocumentsList(documentsList) {
  return {
    type: "SET_DOCUMENTS_LIST",
    payload: {
      documentsList,
    },
  };
}

export function setMandatoryDocumentsStatus(hasMandatoryDocuments) {
  return {
    type: "SET_MANDATORY_DOCUMENTS_STATUS",
    payload: {
      hasMandatoryDocuments,
    },
  };
}

export function setMandatoryDocumentsLoading(loading) {
  return {
    type: "SET_MANDATORY_DOCUMENTS_LOADING",
    payload: {
      loading,
    },
  };
}

export function registerDocumentDownloadAttempt(params, callbackError) {
  return {
    type: "REGISTER_DOCUMENT_DOWNLOAD_ATTEMPT",
    payload: {
      params,
      callbackError,
    },
  };
}